<script lang="ts" setup>
defineProps<{ isOpen: boolean; isLoading: boolean }>();
const emit = defineEmits(['create', 'cancel']);

const handleCancel = () => {
  emit('cancel');
};

const handleCreate = () => {
  emit('create');
};
</script>
<template>
  <v-dialog :model-value="isOpen" max-width="512px" height="550px" persistent>
    <div class="rounded-lg bg-white p-6 text-base shadow-md">
      <div class="mb-2 font-serif text-2xl font-bold text-shade-900">Are you sure?</div>
      <div class="text-shade-900">
        Jobs created here won't sync with your active ATS. If this job's already in your ATS, it
        should be synced here. Activate that synced job instead. If not, create it in your ATS first
        to sync it here.
        <a
          class="text-[blue]"
          data-test="synced-job-help-link"
          href="https://help.factoryfix.com/articles/ats-integrations/how-to-activate-an-ai-recruiter-on-jobs-synced-from-your-ats"
          target="_blank"
          rel="noopener"
          >Learn more.</a
        >
      </div>

      <div class="mt-6 flex flex-row justify-end">
        <v-btn
          :ripple="false"
          class="modal-button-secondary"
          variant="flat"
          :loading="isLoading"
          @click.prevent="handleCancel"
        >
          Cancel
        </v-btn>
        <v-btn
          :ripple="false"
          class="modal-button-primary ml-4"
          :loading="isLoading"
          variant="flat"
          @click.prevent="handleCreate"
        >
          Create Job Anyway
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
